var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue-tags-input", {
        ref: "tags-input",
        staticClass: "ltr",
        attrs: {
          width: "1000",
          tags: _vm.tags,
          placeholder: _vm.tags.length ? "" : "شماره اضافه کنید",
        },
        on: {
          "before-adding-tag": _vm.handleAdd,
          "tags-changed": _vm.handleChange,
        },
        model: {
          value: _vm.tag,
          callback: function ($$v) {
            _vm.tag = $$v
          },
          expression: "tag",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }